import * as Sentry from "@sentry/react";
import { createSyncManager } from "@reciperoll/core";
import { store } from "../store/store";
import { supabase } from "../lib/supabase";
import { webNet } from "./webNet";
import { webImages } from "./webImages";

// The web sync manager: the shared engine from @reciperoll/core with the browser
// adapters. Also registers runSync into the dirty-tracking middleware, so local
// web edits get pushed (debounced) automatically.
export const { runSync } = createSyncManager({
  store,
  supabase,
  net: webNet,
  images: webImages,
  debug: import.meta.env.DEV,
  onError: (error, context) =>
    Sentry.captureException(error, {
      tags: {
        area: "sync",
        op: (context?.op as string) ?? "run",
        ...(context?.code ? { code: String(context.code) } : {}),
      },
      extra: context,
    }),
});
